type ApiErrorLike = {
  message?: unknown;
  error?: { message?: unknown };
  response?: { data?: { error?: { message?: unknown } } };
};

const nonEmptyString = (value: unknown): string | null => (typeof value === "string" && value ? value : null);

export const getApiErrorMessage = (error: unknown): string => {
  const candidate = (error ?? {}) as ApiErrorLike;
  return (
    nonEmptyString(candidate.response?.data?.error?.message) ??
    nonEmptyString(candidate.error?.message) ??
    nonEmptyString(candidate.message) ??
    "Unexpected error"
  );
};
